const score = {
  'score-partwise': {
    '-version': '3.1',
    identification: {
      encoding: {
        software: 'Flat',
        'encoding-date': '2020-06-25'
      },
      source: 'https://flat.io/score/5ef0145fc13875148a01e02b-scale'
    },
    defaults: {
      scaling: {
        millimeters: '7',
        tenths: '40'
      },
      'page-layout': {
        'page-height': '1697.142857142857',
        'page-width': '1200',
        'page-margins': {
          '-type': 'both',
          'left-margin': '98.28571428571429',
          'right-margin': '98.28571428571429',
          'top-margin': '98.28571428571429',
          'bottom-margin': '98.28571428571429'
        }
      },
      'system-layout': { 'system-distance': '115.2' },
      'staff-layout': { 'staff-distance': '72.57142857142857' }
    },
    credit: {
      'credit-type': 'title',
      'credit-words': 'scale'
    },
    'part-list': {
      'score-part': {
        '-id': 'P1',
        'part-name': 'Pan Flute',
        'part-abbreviation': 'Pn. Fl.',
        'score-instrument': {
          '-id': 'P1-I1',
          'instrument-name': 'Pan Flute'
        },
        'midi-instrument': {
          '-id': 'P1-I1',
          'midi-program': '76'
        }
      }
    },
    part: {
      '-id': 'P1',
      measure: [
        {
          '-number': '1',
          attributes: {
            divisions: '1',
            key: { fifths: '0' },
            time: {
              beats: '4',
              'beat-type': '4'
            },
            clef: {
              sign: 'G',
              line: '2',
              'clef-octave-change': '-1'
            },
            'staff-details': { 'staff-lines': '5' }
          },
          sound: { '-tempo': '80' },
          direction: {
            '-placement': 'above',
            'direction-type': {
              metronome: {
                'beat-unit': 'quarter',
                'per-minute': '80'
              }
            },
            staff: '1'
          },
          note: [
            {
              pitch: {
                step: 'C',
                octave: '3'
              },
              duration: '1',
              voice: '1',
              type: 'quarter',
              staff: '1'
            },
            {
              pitch: {
                step: 'D',
                octave: '3'
              },
              duration: '1',
              voice: '1',
              type: 'quarter',
              staff: '1'
            },
            {
              pitch: {
                step: 'E',
                octave: '3'
              },
              duration: '1',
              voice: '1',
              type: 'quarter',
              staff: '1'
            },
            {
              pitch: {
                step: 'F',
                octave: '3'
              },
              duration: '1',
              voice: '1',
              type: 'quarter',
              staff: '1'
            }
          ]
        },
        {
          '-number': '2',
          note: [
            {
              pitch: {
                step: 'G',
                octave: '3'
              },
              duration: '1',
              voice: '1',
              type: 'quarter',
              staff: '1'
            },
            {
              pitch: {
                step: 'A',
                octave: '3'
              },
              duration: '1',
              voice: '1',
              type: 'quarter',
              staff: '1'
            },
            {
              pitch: {
                step: 'B',
                octave: '3'
              },
              duration: '1',
              voice: '1',
              type: 'quarter',
              staff: '1'
            },
            {
              pitch: {
                step: 'C',
                octave: '4'
              },
              duration: '1',
              voice: '1',
              type: 'quarter',
              staff: '1'
            }
          ],
          barline: {
            '-location': 'right',
            'bar-style': 'light-heavy'
          }
        }
      ]
    }
  }
}

export default score
